var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 444 311",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Empty States/No Data") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Creator-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 404,
    transform: "translate(-260.000000, -357.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(260.000000, 357.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 444,
    height: 311
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,279 C412,174.066167 326.933833,89 222,89 C117.066167,89 32,174.066167 32,279 L412,279 Z",
    id: "Fill-1",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.666667,279 L152.333333,279 L152.333333,57.3333333 C152.333333,43.3414167 163.67475,32 177.666667,32 L266.333333,32 C280.32525,32 291.666667,43.3414167 291.666667,57.3333333 L291.666667,279 Z",
    id: "Fill-3",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,92.1666667 C158.004833,92.1666667 152.333333,86.4951667 152.333333,79.5 L152.333333,57.3333333 C152.333333,43.3414167 163.67475,32 177.666667,32 L266.333333,32 C280.32525,32 291.666667,43.3414167 291.666667,57.3333333 L291.666667,79.5 C291.666667,86.4951667 285.995167,92.1666667 279,92.1666667 L165,92.1666667 Z",
    id: "Fill-5",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.666667,279 L152.333333,279 L152.333333,266.333333 C152.333333,262.83575 155.169083,260 158.666667,260 L285.333333,260 C288.830917,260 291.666667,262.83575 291.666667,266.333333 L291.666667,279 Z",
    id: "Fill-7",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.400317,256.833333 L64.93365,256.833333 C57.2370667,256.833333 51.0003167,251.161833 51.0003167,244.166667 L51.0003167,104.833333 C51.0003167,97.8381667 57.2370667,92.1666667 64.93365,92.1666667 L138.400317,92.1666667 C146.095317,92.1666667 152.33365,97.8381667 152.33365,104.833333 L152.33365,244.166667 C152.33365,251.161833 146.095317,256.833333 138.400317,256.833333",
    id: "Fill-9",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.333333,250.5 L177.666667,250.5 C170.6715,250.5 165,244.8285 165,237.833333 L165,111.166667 C165,104.1715 170.6715,98.5 177.666667,98.5 L266.333333,98.5 C273.3285,98.5 279,104.1715 279,111.166667 L279,237.833333 C279,244.8285 273.3285,250.5 266.333333,250.5",
    id: "Fill-11",
    fill: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.166667,244.166667 L180.833333,244.166667 C175.58775,244.166667 171.333333,239.91225 171.333333,234.666667 L171.333333,114.333333 C171.333333,109.08775 175.58775,104.833333 180.833333,104.833333 L263.166667,104.833333 C268.41225,104.833333 272.666667,109.08775 272.666667,114.333333 L272.666667,234.666667 C272.666667,239.91225 268.41225,244.166667 263.166667,244.166667",
    id: "Fill-13",
    fill: "#FFFFCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.666667,256.833333 L76.3333333,256.833333 C69.3381667,256.833333 63.6666667,251.161833 63.6666667,244.166667 L63.6666667,104.833333 C63.6666667,97.8381667 69.3381667,92.1666667 76.3333333,92.1666667 L139.666667,92.1666667 C146.661833,92.1666667 152.333333,97.8381667 152.333333,104.833333 L152.333333,244.166667 C152.333333,251.161833 146.661833,256.833333 139.666667,256.833333",
    id: "Fill-15",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.833333,244.166667 L85.8333333,244.166667 C80.58775,244.166667 76.3333333,239.91225 76.3333333,234.666667 L76.3333333,114.333333 C76.3333333,109.08775 80.58775,104.833333 85.8333333,104.833333 L142.833333,104.833333 C148.078917,104.833333 152.333333,109.08775 152.333333,114.333333 L152.333333,234.666667 C152.333333,239.91225 148.078917,244.166667 142.833333,244.166667",
    id: "Fill-17",
    fill: "#929497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5,142.833333 L174.5,142.833333 C172.752,142.833333 171.333333,141.414667 171.333333,139.666667 C171.333333,137.918667 172.752,136.5 174.5,136.5 L269.5,136.5 C271.248,136.5 272.666667,137.918667 272.666667,139.666667 C272.666667,141.414667 271.248,142.833333 269.5,142.833333",
    id: "Fill-19",
    fill: "#929497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5,177.666667 L174.5,177.666667 C172.752,177.666667 171.333333,176.248 171.333333,174.5 C171.333333,172.752 172.752,171.333333 174.5,171.333333 L269.5,171.333333 C271.248,171.333333 272.666667,172.752 272.666667,174.5 C272.666667,176.248 271.248,177.666667 269.5,177.666667",
    id: "Fill-21",
    fill: "#929497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5,212.5 L174.5,212.5 C172.752,212.5 171.333333,211.081333 171.333333,209.333333 C171.333333,207.585333 172.752,206.166667 174.5,206.166667 L269.5,206.166667 C271.248,206.166667 272.666667,207.585333 272.666667,209.333333 C272.666667,211.081333 271.248,212.5 269.5,212.5",
    id: "Fill-23",
    fill: "#929497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.833333,244.166667 L237.833333,244.166667 C232.58775,244.166667 228.333333,239.91225 228.333333,234.666667 C228.333333,229.421083 232.58775,225.166667 237.833333,225.166667 L256.833333,225.166667 C262.078917,225.166667 266.333333,229.421083 266.333333,234.666667 C266.333333,239.91225 262.078917,244.166667 256.833333,244.166667",
    id: "Fill-25",
    fill: "#6699CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.75,234.666667 C245.75,239.039833 242.2065,242.583333 237.833333,242.583333 C233.460167,242.583333 229.916667,239.039833 229.916667,234.666667 C229.916667,230.2935 233.460167,226.75 237.833333,226.75 C242.2065,226.75 245.75,230.2935 245.75,234.666667",
    id: "Fill-27",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.583333,244.166667 C247.828917,244.166667 252.083333,239.91225 252.083333,234.666667 L261.583333,234.666667 C261.583333,239.91225 257.328917,244.166667 252.083333,244.166667 L242.583333,244.166667 Z",
    id: "Fill-29",
    fill: "#99CCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.166667,234.666667 C244.166667,238.16425 241.330917,241 237.833333,241 C234.33575,241 231.5,238.16425 231.5,234.666667 C231.5,231.169083 234.33575,228.333333 237.833333,228.333333 C241.330917,228.333333 244.166667,231.169083 244.166667,234.666667",
    id: "Fill-31",
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.833333,239.416667 L237.833333,239.416667 C236.085333,239.416667 234.666667,237.998 234.666667,236.25 L234.666667,234.666667 C234.666667,233.791083 235.374417,233.083333 236.25,233.083333 L239.416667,233.083333 C240.29225,233.083333 241,233.791083 241,234.666667 L241,236.25 C241,237.998 239.581333,239.416667 237.833333,239.416667",
    id: "Fill-33",
    fill: "#003333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.666667,234.666667 L367.666667,234.666667 L367.666667,222 C367.666667,215.004833 361.995167,209.333333 355,209.333333 L355,222 C355,228.995167 360.6715,234.666667 367.666667,234.666667",
    id: "Fill-35",
    fill: "#999966"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-37",
    fill: "#231F20",
    points: "315.416667 279 324.916667 279 324.916667 206.166667 315.416667 206.166667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-39",
    fill: "#58595B",
    points: "301.166667 279 310.666667 279 310.666667 206.166667 301.166667 206.166667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#58595B",
    points: "339.166667 279 348.666667 279 348.666667 206.166667 339.166667 206.166667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.666667,206.166667 L301.166667,206.166667 C297.669083,206.166667 294.833333,203.330917 294.833333,199.833333 L294.833333,193.5 L355,193.5 L355,199.833333 C355,203.330917 352.16425,206.166667 348.666667,206.166667",
    id: "Fill-41",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-42",
    fill: "#993300",
    points: "343.916667 193.5 305.916667 193.5 299.583333 161.833333 350.25 161.833333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.25,187.166667 L331.25,187.166667 L331.25,174.5 C331.25,167.504833 325.5785,161.833333 318.583333,161.833333 L318.583333,174.5 C318.583333,181.495167 324.254833,187.166667 331.25,187.166667",
    id: "Fill-43",
    fill: "#CCCC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.333333,279 L380.333333,279 L367.666667,279 C360.6715,279 355,273.3285 355,266.333333 L367.666667,266.333333 C374.661833,266.333333 380.333333,272.004833 380.333333,279",
    id: "Fill-44",
    fill: "#99CC99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.25,161.833333 L331.25,149.166667 L318.583333,149.166667 C311.588167,149.166667 305.916667,154.838167 305.916667,161.833333 L331.25,161.833333 Z",
    id: "Fill-45",
    fill: "#999966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.583333,149.166667 L318.583333,149.166667 L331.25,149.166667 C338.245167,149.166667 343.916667,154.838167 343.916667,161.833333 L331.25,161.833333 C324.254833,161.833333 318.583333,156.161833 318.583333,149.166667",
    id: "Fill-46",
    fill: "#99CC99"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#808184",
    points: "310.666667 253.666667 339.166667 253.666667 339.166667 244.166667 310.666667 244.166667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.333333,79.5 L250.5,79.5 C250.5,82.9975833 253.33575,85.8333333 256.833333,85.8333333 L279,85.8333333 C282.497583,85.8333333 285.333333,82.9975833 285.333333,79.5",
    id: "Fill-48",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.666667,171.333333 L101.666667,171.333333 C94.6715,171.333333 89,165.661833 89,158.666667 L89,149.166667 L152.333333,149.166667 L152.333333,158.666667 C152.333333,165.661833 146.661833,171.333333 139.666667,171.333333",
    id: "Fill-49",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.666667,237.833333 L101.666667,237.833333 C94.6715,237.833333 89,232.161833 89,225.166667 L89,199.833333 L152.333333,199.833333 L152.333333,225.166667 C152.333333,232.161833 146.661833,237.833333 139.666667,237.833333",
    id: "Fill-50",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,165 L117.5,165 C115.752,165 114.333333,163.581333 114.333333,161.833333 L114.333333,149.166667 L120.666667,149.166667 L120.666667,161.833333 C120.666667,163.581333 119.248,165 117.5,165",
    id: "Fill-51",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.833333,158.666667 L104.833333,158.666667 C103.085333,158.666667 101.666667,157.248 101.666667,155.5 L101.666667,152.333333 C101.666667,150.585333 100.248,149.166667 98.5,149.166667 L108,149.166667 L108,155.5 C108,157.248 106.581333,158.666667 104.833333,158.666667",
    id: "Fill-52",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.166667,152.333333 L111.166667,152.333333 C109.418667,152.333333 108,153.752 108,155.5 L108,149.166667 L114.333333,149.166667 L114.333333,155.5 C114.333333,153.752 112.914667,152.333333 111.166667,152.333333",
    id: "Fill-53",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.666667,139.666667 L101.666667,139.666667 C94.6715,139.666667 89,133.995167 89,127 L89,117.5 L152.333333,117.5 L152.333333,127 C152.333333,133.995167 146.661833,139.666667 139.666667,139.666667",
    id: "Fill-54",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.833333,193.5 L130.166667,193.5 C128.418667,193.5 127,194.918667 127,196.666667 L127,234.666667 L139.666667,234.666667 C143.16425,234.666667 146,231.830917 146,228.333333 L146,196.666667 C146,194.918667 144.581333,193.5 142.833333,193.5",
    id: "Fill-55",
    fill: "#663300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,199.833333 L127,199.833333 L127,234.666667 L139.666667,234.666667 C143.16425,234.666667 146,231.830917 146,228.333333 L146,199.833333 Z",
    id: "Fill-56",
    fill: "#CC9966"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#330000",
    points: "130.166667 193.5 142.833333 193.5 142.833333 187.166667 130.166667 187.166667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#663300",
    points: "138.083333 174.5 134.916667 174.5 133.333333 187.166667 139.666667 187.166667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5,114.333333 L212.5,114.333333 C207.254417,114.333333 203,110.078917 203,104.833333 L241,104.833333 C241,110.078917 236.745583,114.333333 231.5,114.333333",
    id: "Fill-59",
    fill: "#FFCC33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5,253.666667 L231.5,253.666667 C233.248,253.666667 234.666667,252.248 234.666667,250.5 L234.666667,247.333333 C234.666667,245.585333 236.085333,244.166667 237.833333,244.166667 L228.333333,244.166667 L228.333333,250.5 C228.333333,252.248 229.752,253.666667 231.5,253.666667",
    id: "Fill-60",
    fill: "#FFFFFF"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.ca4dee5d.svg";
export { ForwardRef as ReactComponent };